module.exports = __webpack_public_path__ + "img/春节大促_28.47133098.png";